<template>
	<sky-charts
		:api-conf="apiConf"
		ref="chart"
		:before-render="beforeRender"
		:queryCondition="condition"
		:config="chartConfig"
	>
		<!--<sky-charts style="width: 300px;" slot="right"  ref="chart" :chart-data="data" :config="lineConf"></sky-charts>-->
	</sky-charts>
</template>

<script>
import apiConf from '@/backend/apiConfig/apiConfig';
import { nameMap } from '@/common/dictionary.js';
import mixins from './ga_mixins';
import weburlSelect from '@/components/website/weburlSelect.js';
import World from 'echarts/map/json/world.json'

export default {
	name: 'ga_map',
	// mixins: [mixins],
	props: {
		condition: {
			required: false,
		},
	},
	data() {
		const that = this;
		return {
			apiConf: null,
			lineConf: {
				type: 'veBar',
			},
			chartConfig: {
				name: '地域分析--TOP5',
				afterConfig: that.afterConf,
				type: 'veMap',

				chartSettings: {
          mapOrigin: World,
					aspectScale: '1.0',
					position: this.position,
					label: false,
					selectData: true,
					labelMap: {
						visitorCount: '用户数量',
					},
					scaleLimit: {
						min: 0.5,
						max: 2,
					},
				},
			},
			data: [],
		};
	},
	watch: {
		condition: {
			handler(val) {
				// if (val.customerId) {
				// 	this.$nextTick(() => {
				// 		this.$refs.chart && this.$refs.chart.initCharts();
				// 	});
				// }

				this.apiConf = {
					api: apiConf.website['get' + weburlSelect(val.status) + 'MapReport'],
          config: {
						timeout: 60000,
					},
				};

				this.chartConfig.chartSettings.position = val.status === 1 ? 'world' : 'china';
				this.chartConfig.height = val.status === 1 ? '400px' : '500px';
				if (val.status === 1) {
					this.chartConfig.columns = this.lineConf.columns = ['countrySource', 'visitorCount'];
				} else {
					this.chartConfig.columns = this.lineConf.columns = ['cityName', 'visitorCount'];
				}
			},
			immediate: true,
			deep: true,
		},
	},
	methods: {
		afterConf(options) {
			Object.assign(options.series[0], {
				left: 10,
				right: '50%',
			});
			options.series.push({
				type: 'bar',
				name: this.lineConf.columns[1],
				data: this.data.map(item => item[this.lineConf.columns[1]]),
				left: 500,
				right: 0,
			});
			options.xAxis = [
				{
					position: 'top',
					type: 'value',
				},
			];
			options.yAxis = [
				{
					type: 'category',
					data: this.data.map(item => item[this.lineConf.columns[0]]),
				},
			];
			options.geo = {};
			options.grid = {
				width: '45%',
				right: 10,
			};
			options.series[0].nameMap = nameMap;
			return options;
		},
		beforeRender(obj) {
			this.data = obj.slice(0, 5).reverse();
			return obj;
		},
	},
};
</script>

<style scoped></style>
